import { createContext, useContext } from "react";

export type ComboboxGroupByValue = string | number;

export type ComboboxGroupContextType = {
  key: ComboboxGroupByValue;
  label: string | null;
} | null;

export const ComboboxGroupContext =
  createContext<ComboboxGroupContextType>(null);

export const useComboboxGroupContext = () => useContext(ComboboxGroupContext);
